
<br />

<div class="oroDefault">

<br />
    <br />
  
    <h2>
        <b>Frequently Asked Questions</b>
    </h2>
    
    <br />

    <div class="oroHub oroContent">

        <table class="oroTextAlignLeft table-striped">
            <tbody>
                <tr *ngFor="let item of this.faqs">
                    <td>
                        Q: {{item.Question}} <br /> A: {{item.Answer}} <br /> <br />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <p>
        <br />
        <button class="btn btn-primary" (click)="gotoHub()" [disabled]="this.isDisabled" title="Go Back">Back</button>
    </p>
</div>
<br />
